/*
 * Page metadata
 */

import React from 'react';
import StripTags from 'striptags';
import { Head } from '@unhead/react';


/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @type {React.FC<any>}
 */
const Meta = (props) => {
    const page = props.page || {};

    // Meta
    const description = props.description || page.searchDescription || page.standfirst || page.description || '';
    const image = props.image || page.metaImage || page.listingImage || page.heroImage;
    const keywords = props.keywords || page.metaKeywords;
    const title = props.title || page.seoTitle || page.title || 'Russell Simpson';
    const url = props.url ? `${props.domain}/${props.url}` : props.domain;
    const noindex = props.noindex || page.noindex;
    const twitterHandle = null;

    return (
        <Head>
            <meta
                content='Russell Simpson'
                name='site_name' />
            {title && <title>
                {title}
            </title>}
            {description && <meta
                content={StripTags(description)}
                name='description' />}
            {keywords && <meta
                content={keywords}
                name='keywords' />}
            {description && <meta
                content={StripTags(description)}
                property='og:description' />}
            <meta
                content={image ? image.src : `${props.domain}/images/social.jpg`}
                property='og:image' />
            {title && <meta
                content={title}
                property='og:title' />}
            {url && <meta
                content={url}
                property='og:url' />}
            <meta
                content='website'
                property='og:type' />
            <meta
                content='summary_large_image'
                name='twitter:card' />
            {twitterHandle && <meta
                content={twitterHandle}
                name='twitter:creator' />}
            {description && <meta
                content={StripTags(description)}
                name='twitter:description' />}
            <meta
                content={image ? image.src : `${props.domain}/images/social.jpg`}
                property='twitter:image:src' />
            {noindex && <meta
                content='noindex'
                name='robots' />}
            {title && <meta
                content={title}
                property='twitter:title' />}
        </Head>
    );

};

/* ========================================================================= */
/* Typing and exports */
/* ========================================================================= */

export default Meta;
